import React, { useEffect, useRef, useState } from "react";
import cx from "classnames";
// import PropTypes from 'prop-types'
import { DateTimeStyled } from "./styled";
import DateTimePicker from "react-datetime-picker";
import "react-datetime-picker/dist/DateTimePicker.css";
import "react-calendar/dist/Calendar.css";
import "react-clock/dist/Clock.css";
import { useTranslation } from "react-i18next";

const isTouchDevice = () =>
  typeof window !== "undefined" &&
  ("ontouchstart" in window || navigator.maxTouchPoints > 0);

const DateTime = ({
  theme_standard,
  theme_bosendorfer,
  format = "dd-MM-y",
  value,
  onChange,
  placeholderText,
  label,
  errors,
  isRequire,
  calendarProps,
  calendarPosition = "bottom", // "top" or "bottom"
  ...props
}) => {
  const customClass = cx({
    theme_standard: theme_standard,
    theme_bosendorfer: theme_bosendorfer,
    calendar_top: calendarPosition === "top",
  });

  const [_value, _setValue] = useState();
  const wrapperRef = useRef(null);

  useEffect(() => {
    if (isTouchDevice() && wrapperRef.current) {
      const inputs = wrapperRef.current.querySelectorAll("input");
      inputs.forEach((input) => {
        input.setAttribute("readOnly", "true");
        input.setAttribute("inputMode", "none");
      });
    }
  }, []);

  useEffect(() => {
    if (value && value !== _value) {
      _setValue(new Date(value));
    }
  }, [value]); // eslint-disable-line react-hooks/exhaustive-deps

  const { t } = useTranslation(["common"]);
  return (
    <DateTimeStyled
      className={customClass}
      isError={!!errors}
      ref={wrapperRef}
    >
      {label && (
        <div className="label">
          {label} {isRequire && <span> *</span>}
        </div>
      )}
      <DateTimePicker
        {...props}
        className={"input"}
        // calendarIcon={null}
        calendarProps={{ className: "input_calendar", ...calendarProps }}
        clearIcon={null}
        format={format}
        value={_value}
        onChange={onChange}
      />
      {errors && <div className="errors">{t(errors, { ns: "common" })}</div>}
    </DateTimeStyled>
  );
};

DateTime.propTypes = {};

export default DateTime;
